<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router/composables'
import { api } from '@/api'
import { useLoadingStore, useToastStore } from '@/stores'
import { isMobile } from '@/utils'
import { $formatErrorMessage, $setToken } from '@/helpers'

const router = useRouter()

const { $showLoading, $hideLoading } = useLoadingStore()
const { $toast } = useToastStore()

const form = ref({
  mobile: '',
  captcha: '',
})

const countdown = ref(0)
async function onSendCode() {
  if (!isMobile(form.value.mobile)) {
    $toast('请输入正确的手机号码')
    return
  }

  try {
    $showLoading()
    await api.post('/gdm/sys/sms', {
      mobile: form.value.mobile,
      smsmode: '2',
    })
    $toast('短信发送成功')
    countdown.value = 60
    startCountdown()
  }
  catch (error: any) {
    $toast($formatErrorMessage(error))
  }
  finally {
    $hideLoading()
  }
}
function startCountdown() {
  if (countdown.value === 0)
    return
  setTimeout(() => {
    countdown.value = countdown.value - 1
    startCountdown()
  }, 1000)
}

async function onSubmit() {
  try {
    const { result } = await api.post<any, any>('/gdm/sys/phoneLogin', {
      ...form.value,
    })
    $setToken(result.token)
    $toast('登录成功')
    router.replace({ name: 'home' })
  }
  catch (error) {
    $toast($formatErrorMessage(error))
  }
}
</script>

<template>
  <div class="h-screen px-5 py-10 bg-white">
    <div>
      <p class="text-2xl text-center font-bold">
        登录
      </p>
    </div>

    <div class="mt-4 rounded-lg overflow-hidden border shadow">
      <input v-model="form.mobile" type="text" maxlength="11" class="w-full h-10 px-4" placeholder="手机号码">
    </div>
    <div class="mt-4 rounded-lg overflow-hidden border shadow relative">
      <input v-model="form.captcha" type="text" maxlength="6" class="w-full h-10 px-4" placeholder="验证码">
      <p v-if="countdown === 0" class="text-sm text-#467FF2 lh-10 px-4 absolute right-0 top-0" @click="onSendCode">
        发送验证码
      </p>
      <p v-else class="text-sm text-#999 lh-10 px-4 absolute right-0 top-0">
        {{ countdown }}秒后重新发送
      </p>
    </div>

    <div>
      <button
        class="mt-4 w-full px-4 py-2 text-white bg-black rounded"
        @click="onSubmit"
      >
        登录
      </button>
    </div>
  </div>
</template>
